import classnames from 'classnames'

import PropTypes from 'prop-types'

import 'shared-web/src/styles/_dropdown.styl'

//#######
// props:
// - onClickOutside
// - renderInnerComponent
//
//#######

const DropDown = React.createClass({
  mixins: [require('react-onclickoutside')],

  propTypes: {
    onClickOutside: PropTypes.func.isRequired,
    renderInnerComponent: PropTypes.func,
    children: PropTypes.node
  },

  getInitialState() { return {} },

  handleClickOutside(event) {
    this.props.onClickOutside(event)
    return event.preventDefault()
  },

  render() {
    return (
      <div className={classnames('DropDown', this.props.className)}>
        {(typeof this.props.renderInnerComponent === 'function' ? this.props.renderInnerComponent() : undefined) || this.props.children}
      </div>
    )
  }


})

export default DropDown



// WEBPACK FOOTER //
// ./src/scripts/components/DropDown.js